<div class="rest_dra">
    <div class="frm_date_dra">
        <div class="page-title-bar flex-sm-row flex-column flex-wrap d-flex justify-content-between align-items-start mb-4">
            <div class="title d-flex align-items-center">
              <button  mat-icon-button (click)="navigate()"  class="me-3">
                <mat-icon class="material-icons-round">arrow_back</mat-icon>
              </button>
              <div>
                <h1 >All activity</h1>
                <h2 class="m-0" *ngIf="pageSubTitle">{{pageSubTitle}}</h2>
              </div>
            </div>
          </div>
           <div class="row" style="
        padding-left: 15px">
            
           <div class="col-sm-8">
            <div class="date-range-form">
              <div class="nw_all">
              <mat-form-field appearance="outline" (click)="fromDatePicker.open()">
                <mat-label>From Date</mat-label>
                <input matInput [matDatepicker]="fromDatePicker"  [(ngModel)]="fromDate" readonly>
                <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #fromDatePicker></mat-datepicker>
              </mat-form-field>
           </div>
           <div class="nw_all">
              <mat-form-field appearance="outline" (click)="toDatePicker.open()">
                <mat-label>To Date</mat-label>
                <input matInput [matDatepicker]="toDatePicker" [(ngModel)]="toDate" readonly>
                <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #toDatePicker></mat-datepicker>
              </mat-form-field>
              </div>
              <div class="search_pag">
              <button (click)="search()" mat-flat-button color="primary" type="submit">{{ 'booking_history.search' | translate }}</button>
          </div>
        </div>
      </div>
           <div class="col-sm-4" style="display: flex;
           justify-content: end;
           gap: 15px;">

                <!-- <div class="create_btn_sd">
                  <button mat-flat-button color="primary" (click)="createNewBooking()" *ngIf="isAccessForEmployeeInvoice">
                      <mat-icon>add</mat-icon> 
                     Booking
                  </button>
              </div> -->


 <!-- new button add -->
           <div class="create_btn_sd">
        <button
          mat-flat-button
          color="primary"
          [matMenuTriggerFor]="addMenu">
          <mat-icon>add</mat-icon>
          Add new
        </button>
        </div>
        <!-- Menu -->
        <mat-menu #addMenu="matMenu">
          <button mat-menu-item (click)="createNewBooking()">
            <mat-icon>event</mat-icon>
            <span>New booking</span>
          </button>
          <button mat-menu-item (click)="addNewInterestFromList()">
            <mat-icon>card_membership</mat-icon>
            <span>New membership request</span>
          </button>
        </mat-menu>
      <!-- end new button -->

           </div>
         
        </div>
    </div>
    <div class="row">
      <div class="col-sm-9">
          <div class="res_fll_sed">
            
          </div>
      </div>
     
     
  </div>

</div>


<div class="chip_cont" style="margin-bottom: 10px;">
   <div class="booing_sectyy">
   <div class="row align-items-center">
      <div class="col-sm-12">
   <div class="booing_sectyy">   
      <mat-chip-list aria-label="Fish selection" class="mb-3" >
         <mat-chip
         (click)="changeChip('1')"
         [ngClass]="{'Graceful-box-active': selectedValue == '1'}"
         style="height: auto">Bookings
         </mat-chip>
      </mat-chip-list>
      <mat-chip-list aria-label="Fish selection" class="mb-3">
         <mat-chip
         (click)="changeChip('2')"
         [ngClass]="{'Graceful-box-active': selectedValue == '2'}"
         style="height: auto">Membership request 
         </mat-chip>
      </mat-chip-list>
      <mat-chip-list aria-label="Fish selection" class="mb-1">
         <mat-chip
         (click)="changeChip('3')"
         [ngClass]="{'Graceful-box-active': selectedValue == '3'}"
        >Customer queries
         </mat-chip>
      </mat-chip-list>

   </div>
</div>

   </div>
   </div>


</div>



    <div class="schedule-container" *ngIf="visible && messageList.length > 0 && selectedValue == '1'">
      <div class="table-container">
          <mat-table [dataSource]="messageList" class="mat-elevation-z1">
            <ng-container matColumnDef="date">
              <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.bookingDate | date}} </mat-cell>
            </ng-container>
         
            <ng-container matColumnDef="customerName">
              <mat-header-cell *matHeaderCellDef> Customer Name </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.customerName}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="noOfServices">
              <mat-header-cell *matHeaderCellDef> No. Of Services </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.servicesCount}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="cost">
              <mat-header-cell *matHeaderCellDef> Cost </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.price}} </mat-cell>
            </ng-container>
        
           
        
            <ng-container matColumnDef="paymentStatus">
              <mat-header-cell *matHeaderCellDef> Payment Status </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.paymentStat}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="startTime">
              <mat-header-cell *matHeaderCellDef> Start Time </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.bookingStartTime}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="endTime">
              <mat-header-cell *matHeaderCellDef> End Time </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.bookingEndTime}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="assignedTo">
              <mat-header-cell *matHeaderCellDef> Assigned To </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.employeeName}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="bookingType">
              <mat-header-cell *matHeaderCellDef> Booking Type </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.booking_type}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="bookingStatus">
              <mat-header-cell *matHeaderCellDef> Booking Status </mat-header-cell>
              <mat-cell *matCellDef="let element" [class.new-booking]="element.bookingStatus == 0 ||element.bookingStatus == 1 || element.bookingStatus == 2" [class.under-process]="element.bookingStatus == 3 || element.bookingStatus == 7 || element.bookingStatus == 9" [class.completed]="element.bookingStatus == 4" [class.cancelled]="element.bookingStatus == 6 || element.bookingStatus == 8" [class.confirmed]="element.bookingStatus == 5"> {{element.bookingStat}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
              <mat-cell *matCellDef="let element" class="menu-cell">
                  <div class="icon-wrapper">
                    <button mat-icon-button class="custom-icon-button"  >
                        <mat-icon>arrow_forward</mat-icon>
                      </button>
                </div>
              
                <mat-menu #menu="matMenu">
                  <button mat-menu-item >
                      <mat-icon class="material-icons-outlined">info</mat-icon>
                      <span>Booking details</span>
                  </button>
                  <!-- <button mat-menu-item (click)="confirmBooking(element)" *ngIf="(((element.bookingStatus == 0 || element.bookingStatus == 1 || element.bookingStatus == 2) && (element.customerInfo.hash_id && element.customerInfo.hash_id != 'null')) && (element.toshowOptions == 1 && isOwner))">
                      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                      <span>Confirm booking</span>
                  </button>
                  <button mat-menu-item *ngIf="element.bookingStatus == 4 && isOwner" (click)="openInvoice(element)">
                      <mat-icon class="material-icons-outlined">badge</mat-icon>
                      <span>Invoice</span>
                  </button>
                  <button mat-menu-item (click)="cancelBooking(element)" *ngIf="(((element.bookingStatus == 0 || element.bookingStatus == 1 || element.bookingStatus == 2 || element.bookingStatus == 5)) && (element.toshowOptions == 1 && isOwner))">
                      <mat-icon class="material-icons-outlined">cancel</mat-icon>
                      <span>Cancel booking</span>
                  </button>
                  <button mat-menu-item *ngIf="(!element.customerInfo.hash_id || element.customerInfo.hash_id == 'null') && isOwner" (click)="deleteBooking(element)">
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                    <span>Delete booking</span>
                  </button> -->

              </mat-menu>



              </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="bookingDetails(row)"></mat-row>
          </mat-table>
        </div>
    </div>

  <ng-template #menuTemplate let-rowvalue>
    <button mat-menu-item (click)="confirmBooking(rowvalue)" *ngIf="(((rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2) && (rowvalue.customerInfo.hash_id && rowvalue.customerInfo.hash_id != 'null')) && (rowvalue.toshowOptions == 1))">
      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
      <span>{{ 'booking_history.opt_confirm_booking' | translate }}</span>
    </button>
    <button mat-menu-item (click)="bookingDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>{{ 'booking_history.opt_booking_details' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.bookingStatus == 4" (click)="openInvoice(rowvalue)">
      <mat-icon class="material-icons-outlined">badge</mat-icon>
      <span>{{ 'booking_history.opt_invoice' | translate }}</span>
    </button>
    <button mat-menu-item (click)="cancelBooking(rowvalue)" *ngIf="(((rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 5)) && (rowvalue.toshowOptions == 1))">
      <mat-icon class="material-icons-outlined">cancel</mat-icon>
      <span>{{ 'booking_history.opt_cancel_booking' | translate }}</span>
    </button>
  </ng-template>

  
  <!-- placeholder html start -->
  <div class="placeholder_started" *ngIf="visible && messageList.length == 0 && selectedValue == '1'">
        <div class="row">

        

          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/booking-history-1.jpg">
                 </div>
                 <mat-card-title>No booking to show.</mat-card-title>
                 <mat-card-content>All the bookings will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
                </mat-card-content>
                 <!-- <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div> -->
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="/assets/images/new-booking.png">
                 </div>
                 <mat-card-title>How to create a new booking?</mat-card-title>
                 <mat-card-content> Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new booking against a business. You can check this video as well. 

                </mat-card-content>
                <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="openvideo()">
                     <mat-icon>play_arrow</mat-icon>
                     Watch video
                  </button>
               </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in getting the list of bookings or issue with managing them, contact our support team. 
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div> 

  <!-- placeholder html end -->



  <!-- MEMBERSHIP QUERIES START -->
<mat-card style="margin-bottom: 10px;" *ngIf="visible && !loader && interestData.length > 0  && selectedValue == '2'">

   <div class="rounded-3 bg-light" >
      <sm-data-table-for-appointments
      [columnHeaders]="tableDisplayColumnsforquery"
      [dataSource]="interestData"
      [showPagination]="true"
      [itemsPerPage]="25"
      [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate"
      [rowClickHandler]="rowClickHandlerforquery"
      >
      <ng-template #costTemplate let-rowVal="row" let-colVal="col">
        adas
      </ng-template>
      </sm-data-table-for-appointments>
   </div>
</mat-card>


<ng-template #menuTemplate let-rowvalue>
   <div>
   <button mat-menu-item (click)="viewDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
      </button>
   <!-- <button mat-menu-item (click)="addReply(rowvalue)" *ngIf="rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">reply</mat-icon>
   <span>Reply</span>
   </button>
   <button mat-menu-item (click)="changeRequestStatus(rowvalue,1)" *ngIf="rowvalue.enrollment_request_status != 1 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">grade</mat-icon>
   <span>Mark as new</span>
   </button>
   <button mat-menu-item (click)="changeRequestStatus(rowvalue,2)" *ngIf="rowvalue.enrollment_request_status != 2 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">hourglass_top</mat-icon>
   <span>Mark as in-progress</span>
   </button>
   <button mat-menu-item (click)="changeRequestStatus(rowvalue,3)" *ngIf="rowvalue.enrollment_request_status != 3 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">task_alt</mat-icon>
   <span>Mark as enrolled</span>
   </button>
   <button mat-menu-item (click)="changeRequestStatus(rowvalue,4)" *ngIf="rowvalue.enrollment_request_status != 4 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">cancel</mat-icon>
   <span>Mark as cancelled</span>
   </button>
   <button mat-menu-item (click)="addAsMember(rowvalue)" *ngIf="rowvalue.enrollment_request_status == 3 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">person_add</mat-icon>
   <span> Add in enrolled members</span>
   </button>
   <button mat-menu-item (click)="deleteQuery(rowvalue)" *ngIf="(!rowvalue.customer_account_hash ||  rowvalue.customer_account_hash == 'null') && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">delete</mat-icon>
   <span> Delete query</span>
   </button> -->
</div>
 

</ng-template>
<!-- placeholder html start -->
<div class="placeholder_started" *ngIf="visible && !loader && interestData.length == 0  && selectedValue == '2'">
   <div class="row">
      <div class="col-sm-4" >
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/query-s1.jpg">
                  </div>
                  <mat-card-title>No queries to show.</mat-card-title>
                  <mat-card-content>All the queries will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
                  </mat-card-content>
                  <!-- <div class="watch_vc_btn" *ngIf="interestType != '4'">
                     <button mat-stroked-button color="primary"  (click)="addNewInterest()">
                        <mat-icon>add</mat-icon>
                        Add new query 
                     </button>
                  </div> -->
               </div>
            </mat-card>
         </div>
      </div>

      <div class="col-sm-4">
         <div class="dashboard_new">
           <mat-card>
               <div class="upload_sectio">
              <div class="icm_img">
                 <img src="/assets/images/new-booking.png">
              </div>
              <mat-card-title>How to create a new query?</mat-card-title>
              <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new query against a business. You can check this video as well. 

             </mat-card-content>
             <div class="watch_vc_btn">
               <button mat-stroked-button color="primary" (click)="openvideo()">
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
               </button>
            </div>
              </div>
           </mat-card>
        </div>
       </div>
      <div class="col-sm-4">
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/helpsupport.png">
                  </div>
                  <mat-card-title>Facing any issue?</mat-card-title>
                  <mat-card-content>For any difficulties in adding a new query or issue with managing them, contact our support team.
                  </mat-card-content>
                  <div class="watch_vc_btn">
                     <button mat-stroked-button color="primary"  (click)="opencontact()">
                        <mat-icon>support_agent</mat-icon>
                        Contact support 
                     </button>
                  </div>
               </div>
            </mat-card>
         </div>
      </div>
   </div>
</div>
<!-- placeholder html end -->


<!-- MEMBERSHIP QUERIES END -->





  <!--  QUERIES START -->
<mat-card style="margin-bottom: 10px;" *ngIf="visible && !loader && queryData.length > 0  && selectedValue == '3'">

   <div class="rounded-3 bg-light" >
      <sm-data-table-for-appointments
      [columnHeaders]="tableDisplayColumnsforserviceQuery"
      [dataSource]="queryData"
      [showPagination]="true"
      [itemsPerPage]="25"
      [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate"
      [rowClickHandler]="rowClickHandlerforservicequery"
      >
      <ng-template #costTemplate let-rowVal="row" let-colVal="col">
        adas
      </ng-template>
      </sm-data-table-for-appointments>
   </div>
</mat-card>


<ng-template #menuTemplate let-rowvalue>
   <div>
   <button mat-menu-item (click)="viewDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
      </button>
  
</div>
 

</ng-template>
<!-- placeholder html start -->
<div class="placeholder_started" *ngIf="visible && !loader && queryData.length == 0  && selectedValue == '3'">
   <div class="row">
      <div class="col-sm-4" >
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/query-s1.jpg">
                  </div>
                  <mat-card-title>No service queries to show.</mat-card-title>
                  <mat-card-content>All the queries will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
                  </mat-card-content>
                  <!-- <div class="watch_vc_btn" *ngIf="interestType != '4'">
                     <button mat-stroked-button color="primary"  (click)="addNewInterest()">
                        <mat-icon>add</mat-icon>
                        Add new query 
                     </button>
                  </div> -->
               </div>
            </mat-card>
         </div>
      </div>

      <!-- <div class="col-sm-4">
         <div class="dashboard_new">
           <mat-card>
               <div class="upload_sectio">
              <div class="icm_img">
                 <img src="/assets/images/new-booking.png">
              </div>
              <mat-card-title>How to create a new query?</mat-card-title>
              <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new query against a business. You can check this video as well. 

             </mat-card-content>
             <div class="watch_vc_btn">
               <button mat-stroked-button color="primary" (click)="openvideo()">
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
               </button>
            </div>
              </div>
           </mat-card>
        </div>
       </div> -->
      <div class="col-sm-4">
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/helpsupport.png">
                  </div>
                  <mat-card-title>Facing any issue?</mat-card-title>
                  <mat-card-content>For any difficulties contact our support team.
                  </mat-card-content>
                  <div class="watch_vc_btn">
                     <button mat-stroked-button color="primary"  (click)="opencontact()">
                        <mat-icon>support_agent</mat-icon>
                        Contact support 
                     </button>
                  </div>
               </div>
            </mat-card>
         </div>
      </div>
   </div>
</div>
<!-- placeholder html end -->


<!--  QUERIES END -->